import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import Service from '../../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import LoadingComponent from '../../loadingComponent';
import { connect } from 'react-redux';
import Authentication from '../../session';
import { BasicLazyParams } from '../../../utile';
import withRouter from '../../lib/withRouter';
import { getBoardsData } from '../../../store/actions';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import BranchToSectionDD from '../../BaseDropdownComponents/BranchToSectionDD';
import ClassetCalendar from '../../../classetComponents/classetCalender';
import ClassetMultiSelect from '../../../classetComponents/classetMultiSelect';
import ClassetInputText from '../../../classetComponents/classetInputText';
import { Menu } from 'primereact/menu';
import { Dialog } from 'primereact/dialog';
import ClassetStudentSearchFilter from '../../Search/ClassetStudentSearchFilter';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';

import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';

const transportStatus = [
    { label: 'ASSIGNED', value: 'ASSIGNED' },
    { label: 'NOT ASSIGNED', value: 'NOT ASSIGNED' },
    { label: 'PENDING', value: 'PENDING' },
    { label: 'REJECTED', value: 'REJECTED' }
]

const changeReasonOptions = [
    { label: 'Parent/Guardian Request', value: 'PARENT_REQUEST' },
    { label: 'Internal Administrative Reason', value: 'ADMIN_INTERNAL' }
];

class AssignManagementTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            assignTransportForm: false,
            isLoading: false,
            users: [],
            isShowUserInfo: false,
            isShowAnalytics: false,
            selectedUser: null,
            isCreateUser: false,
            vehicleDropdown: [],
            selectedServices: {},
            selectedStops: {},
            serviceData: [],
            selectedStudentPickup: {},
            selectedStudentDrop: {},
            planId: '',
            busNo: null,
            boardId: null,
            classId: null,
            totalRecords: 0,
            serverTotalRecords: 0,
            globalSearch: '',
            lazyParams: {
                first: 0,
                rows: 10,
                page: 0
            },
            selectedStudentsInfo: [],
            selectAll: false,
            selectedUsers: [],
            dropdownsData: {},
            searchLevel: 1,
            statusFilter: [],
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'firstName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'lastName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'enrollmentId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'contactPersonName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'parentContactNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'totalFee': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                'refundRaisedAmt': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
            },
            globalFilterValue: '',
            // Change transport dialog state
            showChangeReasonDialog: false,
            changeReasonStudent: null,
            selectedChangeReason: null,
            isChangeMode: {},
            // Assignment dialog state
            showAssignmentDialog: false,
            assignmentDialogStudent: null,
            dialogServiceId: null,
            dialogPickupStopId: null,
            dialogDropStopId: null,
            dialogEffectiveDate: null,
            dialogStops: [],
            isDialogChangeMode: false,
            // Pro-rata manual amounts
            dialogManualClosingAmount: '',
            dialogManualNewFeeAmount: '',
            dialogNoFeeChange: false,
            // Transport fee settings flags
            busFeePlans: null,
            // Fee installments for change dialog
            dialogFeeInstallments: [],
            dialogFeeInstallmentsLoading: false,
            dialogInstallmentNewAmounts: {}
        };
        this.service = new Service();
    }

    componentDidMount() { }

    onCancel = () => {
        this.setState(
            {
                assignTransportForm: false,
                dataForAddRoutes: {}
            },
            () => this.getServicesDataForDropdown()
        );
    };

    getServicesDataForDropdown = async () => {
        const academicYear = localStorage.getItem('userAcademicYear');
        this.setState({ isLoading: true });
        let url = `${baseUrlAdmin}/transport-service/dropdown`;
        let payload = {
            branchId: this.state?.dropdownsData?.branchId || null,
            orgId: localStorage.getItem('orgId'),
            academicYear: academicYear
        };
        try {
            const res = await this.service.post(url, payload, true);
            if (res?.res?.status && res.status) {
                const serviceDropdown = res?.res?.data?.map((service) => ({
                    label: service.label,
                    value: service.value,
                    stops: service.stops || [],
                    routeId: service.routeId,
                    routeName: service.routeName,
                    vehicleNumber: service.vehicleNumber,
                    serviceName: service.serviceName,
                    isDifferentialRouteFee: service.isDifferentialRouteFee,
                    commonTransportFee: service.commonTransportFee
                }));
                this.setState({
                    vehicleDropdown: serviceDropdown,
                    serviceData: res?.res?.data,
                    isLoading: false
                }, () => this.getAssignTransportData());
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res?.errMessage || 'Failed to load services', life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    };

    componentDidUpdate(prevProps, prevState) {
        // Add to existing componentDidUpdate
        if (prevProps.boards !== this.props.boards) {
            if (this.props.boards) {
                let boards = [];
                this.props.boards &&
                    this.props.boards.map((item,) => {
                        boards.push({ value: item.boardId, label: item.boardName });
                    });

                this.setState({
                    boards: boards
                });
            }
        }

        if (prevProps.branchData !== this.props.branchData) {
            let sectionsData = {
                level1: this.props.branchData.filter((a) => a.level == 1)
            };
            this.setState({
                sectionsData
            });
        }

        // Add this condition to handle status filter changes
        if (prevState.statusFilter !== this.state.statusFilter) {
            this.applyPagination();
        }
    }

    onChangeBoard = (boardId) => {
        this.setState({
            classes: [],
            classId: null,
            curriculumInfo: null,
            isShowSubjects: false
        });
        const _classes = [];
        const selectedBoard = this.props.boards && this.props.boards.find((board) => board.boardId === boardId);
        if (selectedBoard && selectedBoard?.classes && selectedBoard?.classes?.length > 0) {
            selectedBoard?.classes.forEach((item) => _classes?.push({ label: item.className, value: item.classId, groupId: item?.groups ? item?.groups[0]?.groupId : '' }));
        }
        let selectedBoardName = this.props.boards?.find((board) => board.boardId == boardId).boardName;
        this.setState({
            classes: _classes,
            boardId,
            selectedSubject: [],
            selectedChapter: [],
            selectedTopic: [],
            selectedBoardName: selectedBoardName
        });
    };

    onChangeClass = (classId) => {
        let selectedClass = this.state?.classes?.find((classd) => classd.value == classId);
        this.setState({
            classId: classId,
            selectedSubject: [],
            selectedChapter: [],
            selectedTopic: [],
            selectedClassName: selectedClass?.label,
            groupId: selectedClass.groupId
        });
    };

    onPage = (event) => {
        const lazyParams = { ...this.state.lazyParams, ...event };
        this.setState({ lazyParams }, () => this.getAssignTransportData());
    };

    applyPagination = () => {
        const { users, statusFilter, serverTotalRecords } = this.state;

        let filteredData = users;
        if (statusFilter && statusFilter.length > 0) {
            filteredData = users.filter(user => {
                return statusFilter.some(status =>
                    status === user.isAssigned ||
                    (status === 'NOT ASSIGNED' && !user.isAssigned)
                );
            });
        }

        this.setState({
            filteredUsers: filteredData,
            totalRecords: statusFilter && statusFilter.length > 0 ? filteredData.length : serverTotalRecords
        });
    };

    getAssignTransportData = async () => {
        const academicYear = localStorage.getItem('userAcademicYear');
        this.setState({ isLoading: true });
        const { lazyParams } = this.state;
        const page = (lazyParams?.page || 0) + 1;
        const limit = lazyParams?.rows || 10;

        let url = `${baseUrlAdmin}/transport-route/students/getforRoutes?boardId=${this.state?.dropdownsData?.boardId || ''}&gradeId=${this.state?.dropdownsData?.classId || ''}&sectionId=${this.state?.dropdownsData?.sectionId || ''}&academicYear=${academicYear}&status=Active&page=${page}&limit=${limit}`;

        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const users = res?.res?.data?.addmissionTransport || [];
                const serverTotalRecords = res?.res?.data?.totalRecords || 0;

                const selectedServices = {};
                const selectedStops = {};
                const selectedStudentPickup = {};
                const selectedStudentDrop = {};

                users.forEach((user) => {
                    const uniqueKey = user.user_id; // Use user_id as unique key for pagination support
                    // For V2: use serviceId and find matching service from dropdown
                    const userServiceId = user.serviceId?.toString?.() || user.serviceId;
                    if (userServiceId) {
                        const service = this.state.serviceData.find((s) => s.value === userServiceId);
                        if (service) {
                            selectedServices[uniqueKey] = service.value;
                            selectedStops[uniqueKey] = service.stops;
                        }
                    }
                    // Use V2 field names - get stop _id as string for dropdown value
                    const pickupStopId = user.selectedPickUpStop?._id?.toString?.() || user.selectedPickUpStop?._id || user.selectedPickUpStop?.value;
                    const dropStopId = user.selectedDropStop?._id?.toString?.() || user.selectedDropStop?._id || user.selectedDropStop?.value;
                    selectedStudentPickup[uniqueKey] = pickupStopId;
                    selectedStudentDrop[uniqueKey] = dropStopId;
                });

                this.setState({
                    users,
                    usersInfo: users,
                    selectedServices,
                    selectedStops,
                    selectedStudentPickup,
                    selectedStudentDrop,
                    isLoading: false,
                    serverTotalRecords,
                    totalRecords: serverTotalRecords,
                }, () => {
                    this.applyPagination();
                });
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: '', detail: res?.errMessage, life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    };


    setDropdownValues = (dropdownsData = {}) => {
        this.setState(
            {
                dropdownsData,
                filteredUsers: [],
                users: [],
                totalRecords: 0,
                serverTotalRecords: 0,
                selectedStudentsInfo: [],
                selectAll: false,
                lazyParams: {
                    ...this.state.lazyParams,
                    first: 0,
                    page: 0
                }
            },
            async () => {
                if (
                    dropdownsData?.boardId &&
                    dropdownsData?.classId &&
                    dropdownsData?.branchId &&
                    dropdownsData?.sectionId
                ) {
                    await this.getServicesDataForDropdown();
                }
            }
        );
    };
    onAssignTransport = (rowData) => {
        const { selectedStudentsInfo, filteredUsers, serviceData } = this.state;
        const selectedUsers = selectedStudentsInfo.length > 0
            ? filteredUsers.filter(user => selectedStudentsInfo.some(selectedUser => selectedUser._id === user._id))
            : rowData ? [rowData] : [];

        if (selectedUsers.length === 0) {
            return this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please select at least one student',
                life: 3000
            });
        }

        try {
            // Create a map of service capacities (based on vehicle seating)
            const serviceCapacities = {};
            serviceData?.forEach(service => {
                if (service?.value) {
                    serviceCapacities[service.value] = {
                        seatingCapacity: service.seatingCapacity || 0,
                        requestedCapacity: service.requestedCapacity || 0,
                        serviceName: service.serviceName
                    };
                }
            });

            // Count new requests per service
            const serviceRequests = {};
            selectedUsers.forEach(user => {
                const newServiceId = user?.serviceInfo?.value;
                if (!newServiceId) return;

                // Find user's existing service from usersInfo
                const existingUser = this.state.usersInfo.find(u => u._id === user._id);
                const existingServiceId = existingUser?.serviceId?.toString?.() || existingUser?.serviceId;

                // If user is changing services
                if (existingServiceId !== newServiceId) {
                    serviceRequests[newServiceId] = (serviceRequests[newServiceId] || 0) + 1;

                    if (existingServiceId && serviceCapacities[existingServiceId]) {
                        serviceCapacities[existingServiceId].requestedCapacity =
                            Math.max(0, (serviceCapacities[existingServiceId].requestedCapacity || 0) - 1);
                    }
                }
            });

            // Check capacity for each service
            for (const serviceId in serviceRequests) {
                if (!serviceCapacities[serviceId]) continue;

                const { seatingCapacity, requestedCapacity, serviceName } = serviceCapacities[serviceId];
                const newRequests = serviceRequests[serviceId];
                const availableSeats = seatingCapacity - requestedCapacity;

                if (newRequests > availableSeats) {
                    return this.toast.show({
                        severity: 'error',
                        summary: 'Capacity Exceeded',
                        detail: `Service "${serviceName}" has insufficient capacity. Available: ${availableSeats}, Requested: ${newRequests}`,
                        life: 3000
                    });
                }
            }

            // Check if all selected students have at least one of pickup or drop stop, and an effective date
            const invalidAssignments = selectedUsers.filter(user => {
                const hasPickupStop = user?.selectedPickUpStop && Object.keys(user?.selectedPickUpStop || {}).length > 0;
                const hasDropStop = user?.selectedDropStop && Object.keys(user?.selectedDropStop || {}).length > 0;
                const hasEffectiveDate = !!user?.effectiveDate;
                return (!hasPickupStop && !hasDropStop) || !hasEffectiveDate;
            });

            // Create locationInfo object for valid assignments
            let locationInfo = {};

            selectedUsers.forEach(user => {
                // Get service information - use serviceId for V2
                const userServiceId = user.serviceInfo?.value || user.serviceInfo?._id || user.serviceId?.toString?.() || user.serviceId;
                const userService = this.state.serviceData.find(service =>
                    service.value === userServiceId
                );

                if (userService) {
                    // Set serviceId and serviceInfo on the user for the backend
                    user.serviceId = userService.value;
                    user.serviceInfo = {
                        _id: userService.value,
                        serviceName: userService.serviceName,
                        routeId: userService.routeId,
                        vehicleId: userService.vehicleId,
                        routeName: userService.routeName,
                        routeNo: userService.routeNo,
                        vehicleNumber: userService.vehicleNumber,
                        seatingCapacity: userService.seatingCapacity,
                        isDifferentialRouteFee: userService.isDifferentialRouteFee
                    };

                    // Extract pickup stop details if available
                    if (user.selectedPickUpStop && user.selectedPickUpStop._id) {
                        const pickupStop = userService?.stops?.find(stop => stop.value === user.selectedPickUpStop._id);
                        if (pickupStop) {
                            locationInfo.pickUpTime = pickupStop.pickUpTime ? new Date(pickupStop.pickUpTime) : null;
                            locationInfo.pickupLatitude = pickupStop.latitude;
                            locationInfo.pickupLongitude = pickupStop.longitude;
                            locationInfo.pickupLandmark = pickupStop.landmark;
                            // Enrich selectedPickUpStop with full stop details
                            user.selectedPickUpStop = {
                                ...user.selectedPickUpStop,
                                stopName: pickupStop.stopName,
                                transportFee: pickupStop.transportFee,
                                pickUpTime: pickupStop.pickUpTime,
                                latitude: pickupStop.latitude,
                                longitude: pickupStop.longitude,
                                landmark: pickupStop.landmark
                            };
                        }
                    }

                    // Extract drop stop details if available
                    if (user.selectedDropStop && user.selectedDropStop._id) {
                        const dropStop = userService?.stops?.find(stop => stop.value === user.selectedDropStop._id);
                        if (dropStop) {
                            locationInfo.dropTime = dropStop.dropTime ? new Date(dropStop.dropTime) : null;
                            locationInfo.dropLatitude = dropStop.latitude;
                            locationInfo.dropLongitude = dropStop.longitude;
                            locationInfo.dropLandmark = dropStop.landmark;
                            // Enrich selectedDropStop with full stop details
                            user.selectedDropStop = {
                                ...user.selectedDropStop,
                                stopName: dropStop.stopName,
                                transportFee: dropStop.transportFee,
                                dropTime: dropStop.dropTime,
                                latitude: dropStop.latitude,
                                longitude: dropStop.longitude,
                                landmark: dropStop.landmark
                            };
                        }
                    }

                    user.locationInfo = locationInfo;
                    locationInfo = {};
                }
            });

            if (invalidAssignments.length > 0) {
                return this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Please select at least one stop (pickup or drop) and effective date for all selected students',
                    life: 3000
                });
            }

            // Process valid assignments
            console.log("Valid assignments:", selectedUsers);

            this.setState({
                dataForAddRoutes: selectedUsers,
            }, this.onRaiseRequest);

        } catch (error) {
            console.error('Error in onAssignTransport:', error);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'An error occurred while processing the transport assignment',
                life: 3000
            });
        }
    }; // Added missing closing brace and semicolon

    onRaiseRequest = async () => {
        const academicYear = localStorage.getItem('userAcademicYear');
        this.setState({ isLoading: true });
        const { dataForAddRoutes } = this.state;

        if (!Array.isArray(dataForAddRoutes) || dataForAddRoutes.length === 0) {
            this.setState({ isLoading: false });
            return this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No students selected for transport assignment',
                life: 3000
            });
        }
        // Get hierarchy information
        const selectedHierarchy = {
            boardId: this.state.dropdownsData.boardId,
            gradeId: this.state.dropdownsData.classId,
            sectionId: this.state.dropdownsData.sectionId,
            branchId: this.state.dropdownsData.branchId
        };

        const requests = dataForAddRoutes.map(student => {
            // Create a deep copy to avoid modifying original data
            const studentData = { ...student };
            // Remove stops from routeInfo to reduce payload size
            if (studentData?.routeInfo?.stops) {
                delete studentData.routeInfo.stops;
            }
            // Remove stops from serviceInfo if present
            if (studentData?.serviceInfo?.stops) {
                delete studentData.serviceInfo.stops;
            }

            // Prepare location info
            const locationInfo = {
                pickUpTime: studentData.locationInfo?.pickUpTime,
                dropTime: studentData.locationInfo?.dropTime,
                pickupLatitude: studentData.locationInfo?.pickupLatitude,
                pickupLongitude: studentData.locationInfo?.pickupLongitude,
                pickupLandmark: studentData.locationInfo?.pickupLandmark,
                dropLatitude: studentData.locationInfo?.dropLatitude,
                dropLongitude: studentData.locationInfo?.dropLongitude,
                dropLandmark: studentData.locationInfo?.dropLandmark
            };

            return {
                ...locationInfo,
                ...studentData,
            };
        });



        let payload = {
            academicYear,
            dataForAddRoutes: requests,
            ...selectedHierarchy
        };
        let url = `${baseUrlAdmin}/transport-assign-approval/assign/request`;
        try {
            const res = await this.service.post(url, payload, true);
            if (res?.res?.status && res.status) {
                this.setState({
                    isLoading: false,
                    selectedStudentsInfo: [],
                    isChangeMode: {},
                });

                this.toast.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: res?.res?.message,
                    life: 3000
                });
                await this.getServicesDataForDropdown();
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res?.errMessage, life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    };
    onSelectAllChange = (event) => {
        const { checked } = event;
        const { filteredUsers, usersInfo } = this.state;
        console.log(filteredUsers, usersInfo, "filteredUsers, usersInfo")
        // Filter out students without fee plan or with pending status
        const validStudentsForSelection = filteredUsers.filter(student =>
            student.isFeePlanAssigned === true && student.isAssigned !== "PENDING"
        );

        if (validStudentsForSelection.length === 0) {
            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Cannot select students without transport fee plan or with pending status',
                life: 3000
            });
            return;
        }

        // Check for changes by comparing with original data
        const studentsWithChanges = validStudentsForSelection.filter(student => {
            const originalStudent = usersInfo.find(u => u._id === student._id);
            if (!originalStudent) return false;

            // Check if pickup stop, drop stop or effective date has changed (use V2 field names)
            const originalPickupId = originalStudent.selectedPickUpStop?._id?.toString?.() || originalStudent.selectedPickUpStop?._id;
            const originalDropId = originalStudent.selectedDropStop?._id?.toString?.() || originalStudent.selectedDropStop?._id;
            const currentPickupId = student.selectedPickUpStop?._id?.toString?.() || student.selectedPickUpStop?._id;
            const currentDropId = student.selectedDropStop?._id?.toString?.() || student.selectedDropStop?._id;

            const pickupChanged = currentPickupId && currentPickupId !== originalPickupId;
            const dropChanged = currentDropId && currentDropId !== originalDropId;
            const effectiveDateChanged = student.effectiveDate !== originalStudent.effectiveDate;

            return pickupChanged || dropChanged || effectiveDateChanged;
        });

        if (studentsWithChanges.length === 0) {
            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'No changes detected in student transport details',
                life: 3000
            });
            return;
        }

        // Only select students that have changes
        const selectedStudentsInfo = checked ? studentsWithChanges : [];

        this.setState({
            selectedStudentsInfo,
            selectAll: checked && studentsWithChanges.length === validStudentsForSelection.length
        });
    };
    onSelectionChange = (event) => {
        // Check for invalid selections first
        const hasInvalidSelection = event.value.some(student =>
            student.isFeePlanAssigned === false || student.isAssigned === "PENDING"
        );

        if (hasInvalidSelection) {
            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Cannot select students without transport fee plan or with pending status',
                life: 3000
            });
            return;
        }

        // Get the currently selected student IDs
        const currentSelectedIds = this.state.selectedStudentsInfo.map(student => student._id);
        // Get the newly selected student IDs
        const newSelectedIds = event.value.map(student => student._id);

        // Check if we're deselecting
        const isDeselecting = currentSelectedIds.some(id => !newSelectedIds.includes(id));
        if (isDeselecting) {
            this.setState({
                selectedStudentsInfo: event.value,
                selectAll: event.value.length === this.state.filteredUsers.length
            });
            return;
        }

        // For new selections, check if all required fields are filled
        const newlySelectedStudents = event.value.filter(student =>
            !currentSelectedIds.includes(student._id)
        );

        const hasIncompleteData = newlySelectedStudents.some(student => {
            // Use user_id as key (matching how we store in selectedServices)
            const serviceId = this.state.selectedServices[student.user_id];
            const pickupStop = student.selectedPickUpStop?._id;
            const dropStop = student.selectedDropStop?._id;
            const effectiveDate = student.effectiveDate;

            // Must have service, at least one stop (pickup or drop), and effective date
            return !serviceId ||
                (!pickupStop && !dropStop) ||
                !effectiveDate;
        });

        if (hasIncompleteData) {
            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please select service, at least one stop (pickup or drop), and effective date before selecting the student',
                life: 3000
            });
            return;
        }

        // Check for changes in selected data
        const hasChanges = event.value.some(selectedStudent => {
            const originalStudent = this.state.usersInfo.find(u => u._id === selectedStudent._id);
            if (!originalStudent) return false;

            // Use V2 field names for comparison
            const originalPickupId = originalStudent.selectedPickUpStop?._id?.toString?.() || originalStudent.selectedPickUpStop?._id;
            const originalDropId = originalStudent.selectedDropStop?._id?.toString?.() || originalStudent.selectedDropStop?._id;
            const currentPickupId = selectedStudent.selectedPickUpStop?._id?.toString?.() || selectedStudent.selectedPickUpStop?._id;
            const currentDropId = selectedStudent.selectedDropStop?._id?.toString?.() || selectedStudent.selectedDropStop?._id;

            const pickupChanged = currentPickupId && currentPickupId !== originalPickupId;
            const dropChanged = currentDropId && currentDropId !== originalDropId;
            const effectiveDateChanged = selectedStudent.effectiveDate !== originalStudent.effectiveDate;

            return pickupChanged || dropChanged || effectiveDateChanged;
        });

        if (!hasChanges) {
            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'No changes detected in the selected student\'s transport details',
                life: 3000
            });
            return;
        }

        this.setState({
            selectedStudentsInfo: event.value,
            selectAll: event.value.length === this.state.filteredUsers.length
        });

    };

    getValidDate = (dateValue) => {
        if (!dateValue) return null;
        const date = new Date(dateValue);
        return isNaN(date.getTime()) ? null : date;
    };

    handleSearchLevel = (level) => {
        this.setState({ searchLevel: level });
        // Optionally clear dropdownsData or filteredUsers if needed
    };

    validateServiceFee = (selectedService) => {
        if (!selectedService) return { isValid: true };

        // If differential fee is OFF, check route-level fee (commonTransportFee)
        if (!selectedService.isDifferentialRouteFee) {
            const routeFee = selectedService.commonTransportFee;
            if (!routeFee || routeFee <= 0) {
                return {
                    isValid: false,
                    message: `Transport fee is not configured for the route "${selectedService.routeName || selectedService.serviceName}". Please contact the administrator to set up the route fee.`
                };
            }
        }
        return { isValid: true };
    };

    validateStopFee = (selectedService, stop, stopType) => {
        if (!selectedService || !stop) return { isValid: true };

        // If differential fee is ON, check stop-level fee
        if (selectedService.isDifferentialRouteFee) {
            if (!stop.transportFee || stop.transportFee <= 0) {
                return {
                    isValid: false,
                    message: `Transport fee is not configured for ${stopType} stop "${stop.stopName || stop.label}". Please contact the administrator to set up the stop fee.`
                };
            }
        }
        return { isValid: true };
    };

    // Add this method to prevent row selection when clicking inputs
    preventRowSelection = (e) => {
        e.stopPropagation();
    };

    // Handle change transport button click for assigned students
    onChangeTransportClick = (rowData) => {
        this.setState({
            showChangeReasonDialog: true,
            changeReasonStudent: rowData,
            selectedChangeReason: null
        });
    };

    // Confirm change reason and enable editing for the student
    onConfirmChangeReason = () => {
        const { changeReasonStudent, selectedChangeReason } = this.state;
        if (!selectedChangeReason) {
            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please select a reason for the transport change',
                life: 3000
            });
            return;
        }

        const uniqueKey = changeReasonStudent.user_id;

        // Enable editing for this student
        const updateUserFn = (user) =>
            user.user_id === uniqueKey
                ? {
                    ...user,
                    changeReason: selectedChangeReason,
                    isInChangeMode: true,
                    // Clear previous selections to force re-selection
                    effectiveDate: null
                }
                : user;

        this.setState((prevState) => ({
            showChangeReasonDialog: false,
            changeReasonStudent: null,
            isChangeMode: { ...prevState.isChangeMode, [uniqueKey]: true },
            users: prevState.users.map(updateUserFn),
            filteredUsers: prevState.filteredUsers.map(updateUserFn)
        }));

        this.toast.show({
            severity: 'info',
            summary: 'Change Mode Enabled',
            detail: 'Transport fees will be recalculated based on new assignment',
            life: 5000
        });
    };

    // Cancel change transport
    onCancelChangeReason = () => {
        this.setState({
            showChangeReasonDialog: false,
            changeReasonStudent: null,
            selectedChangeReason: null
        });
    };

    // Check if student is in change mode or can be edited
    canEditStudent = (rowData) => {
        if (rowData?.isFeePlanAssigned === false) return false;
        if (rowData?.isAssigned === "PENDING") return false;
        // Allow editing if student is not assigned OR is in change mode
        if (rowData?.isAssigned !== "ASSIGNED") return true;
        return this.state.isChangeMode[rowData.user_id] === true;
    };

    // Open assignment dialog for a student
    openAssignmentDialog = (rowData, isChange = false) => {
        if (rowData?.isFeePlanAssigned === false) {
            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Transport fee plan not assigned to this student',
                life: 3000
            });
            return;
        }
        if (rowData?.isAssigned === "PENDING") {
            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'This student has a pending approval request',
                life: 3000
            });
            return;
        }

        const uniqueKey = rowData.user_id;
        const currentServiceId = this.state.selectedServices[uniqueKey] || null;
        const currentService = this.state.serviceData.find(s => s.value === currentServiceId);

        this.setState({
            showAssignmentDialog: true,
            assignmentDialogStudent: rowData,
            dialogServiceId: currentServiceId,
            dialogPickupStopId: this.state.selectedStudentPickup[uniqueKey] || null,
            dialogDropStopId: this.state.selectedStudentDrop[uniqueKey] || null,
            dialogEffectiveDate: this.getValidDate(rowData.effectiveDate),
            dialogStops: currentService?.stops || [],
            isDialogChangeMode: isChange,
            selectedChangeReason: isChange ? null : undefined,
            dialogFeeInstallments: [],
            dialogInstallmentNewAmounts: {},
        });

        if (isChange && rowData.user_id) {
            this.fetchTransportFeeInstallments(rowData.user_id);
        }
    };

    fetchTransportFeeInstallments = async (userId) => {
        const academicYear = localStorage.getItem('userAcademicYear');
        this.setState({ dialogFeeInstallmentsLoading: true });
        try {
            const url = `${baseUrlAdmin}/transport-route/students/transport-fee-installments?userId=${userId}&academicYear=${academicYear}`;
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                this.setState({
                    dialogFeeInstallments: res.res.data || [],
                    dialogFeeInstallmentsLoading: false
                });
            } else {
                this.setState({ dialogFeeInstallments: [], dialogFeeInstallmentsLoading: false });
            }
        } catch (e) {
            this.setState({ dialogFeeInstallments: [], dialogFeeInstallmentsLoading: false });
        }
    };

    // Close assignment dialog
    closeAssignmentDialog = () => {
        this.setState({
            showAssignmentDialog: false,
            assignmentDialogStudent: null,
            dialogServiceId: null,
            dialogPickupStopId: null,
            dialogDropStopId: null,
            dialogEffectiveDate: null,
            dialogStops: [],
            isDialogChangeMode: false,
            selectedChangeReason: null,
            dialogManualClosingAmount: '',
            dialogManualNewFeeAmount: '',
            dialogNoFeeChange: false,
            dialogFeeInstallments: [],
            dialogFeeInstallmentsLoading: false,
            dialogInstallmentNewAmounts: {},
        });
    };

    // Handle dialog service change
    onDialogServiceChange = (serviceId) => {
        const selectedService = this.state.serviceData.find(s => s.value === serviceId);

        // Validate service fee
        const feeValidation = this.validateServiceFee(selectedService);
        if (!feeValidation.isValid) {
            this.toast.show({
                severity: 'error',
                summary: 'Fee Not Configured',
                detail: feeValidation.message,
                life: 5000
            });
            return;
        }

        this.setState({
            dialogServiceId: serviceId,
            dialogStops: selectedService?.stops || [],
            dialogPickupStopId: null,
            dialogDropStopId: null
        });
    };

    // Handle dialog pickup stop change
    onDialogPickupChange = (stopId) => {
        const selectedService = this.state.serviceData.find(s => s.value === this.state.dialogServiceId);
        const stop = selectedService?.stops?.find(s => s.value === stopId);

        const feeValidation = this.validateStopFee(selectedService, stop, 'pickup');
        if (!feeValidation.isValid) {
            this.toast.show({
                severity: 'error',
                summary: 'Fee Not Configured',
                detail: feeValidation.message,
                life: 5000
            });
            return;
        }

        this.setState({ dialogPickupStopId: stopId });
    };

    // Handle dialog drop stop change
    onDialogDropChange = (stopId) => {
        const selectedService = this.state.serviceData.find(s => s.value === this.state.dialogServiceId);
        const stop = selectedService?.stops?.find(s => s.value === stopId);

        const feeValidation = this.validateStopFee(selectedService, stop, 'drop');
        if (!feeValidation.isValid) {
            this.toast.show({
                severity: 'error',
                summary: 'Fee Not Configured',
                detail: feeValidation.message,
                life: 5000
            });
            return;
        }

        this.setState({ dialogDropStopId: stopId });
    };

    // Submit assignment from dialog
    submitAssignmentDialog = () => {
        const {
            assignmentDialogStudent,
            dialogServiceId,
            dialogPickupStopId,
            dialogDropStopId,
            dialogEffectiveDate,
            isDialogChangeMode,
            selectedChangeReason,
            busFeePlans,
            dialogNoFeeChange,
            dialogFeeInstallments,
            dialogInstallmentNewAmounts,
        } = this.state;

        // Validation
        if (!dialogServiceId) {
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please select a service', life: 3000 });
            return;
        }
        if (!dialogPickupStopId && !dialogDropStopId) {
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please select at least one stop (pickup or drop)', life: 3000 });
            return;
        }
        if (!dialogEffectiveDate) {
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please select an effective date', life: 3000 });
            return;
        }
        if (isDialogChangeMode && !selectedChangeReason) {
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Please select a reason for transport change', life: 3000 });
            return;
        }
        // Validate per-installment new entry amounts in change mode
        if (isDialogChangeMode && !dialogNoFeeChange && dialogFeeInstallments.length > 0) {
            for (const inst of dialogFeeInstallments) {
                const key = inst._id?.toString();
                const rawVal = dialogInstallmentNewAmounts[key];
                const newAmt = Number(rawVal);
                if (rawVal === undefined || rawVal === '' || isNaN(newAmt) || newAmt < 0) {
                    this.toast.show({ severity: 'error', summary: 'Error', detail: `Please enter a valid New Entry Amount for ${inst.termName}`, life: 3000 });
                    return;
                }
                if (newAmt < (inst.paidAmount || 0)) {
                    this.toast.show({
                        severity: 'error',
                        summary: 'Validation Error',
                        detail: `New Entry Amount for ${inst.termName} (₹${newAmt}) cannot be less than the paid amount (₹${inst.paidAmount})`,
                        life: 5000
                    });
                    return;
                }
            }
        }
        const showManualAmounts = false;

        const uniqueKey = assignmentDialogStudent.user_id;
        const selectedService = this.state.serviceData.find(s => s.value === dialogServiceId);
        const pickupStop = selectedService?.stops?.find(s => s.value === dialogPickupStopId);
        const dropStop = selectedService?.stops?.find(s => s.value === dialogDropStopId);

        // Update the user data
        const updateUserFn = (user) => {
            if (user.user_id !== uniqueKey) return user;
            return {
                ...user,
                serviceId: dialogServiceId,
                serviceInfo: {
                    _id: selectedService.value,
                    value: selectedService.value,
                    serviceName: selectedService.serviceName,
                    routeId: selectedService.routeId,
                    vehicleId: selectedService.vehicleId,
                    routeName: selectedService.routeName,
                    routeNo: selectedService.routeNo,
                    vehicleNumber: selectedService.vehicleNumber,
                    seatingCapacity: selectedService.seatingCapacity,
                    isDifferentialRouteFee: selectedService.isDifferentialRouteFee
                },
                routeName: selectedService?.routeName,
                vehicleRegistrationNo: selectedService?.vehicleNumber,
                selectedPickUpStop: pickupStop ? {
                    _id: pickupStop.value,
                    stopName: pickupStop.stopName || pickupStop.label,
                    transportFee: pickupStop.transportFee,
                    pickUpTime: pickupStop.pickUpTime,
                    latitude: pickupStop.latitude,
                    longitude: pickupStop.longitude,
                    landmark: pickupStop.landmark
                } : null,
                selectedDropStop: dropStop ? {
                    _id: dropStop.value,
                    stopName: dropStop.stopName || dropStop.label,
                    transportFee: dropStop.transportFee,
                    dropTime: dropStop.dropTime,
                    latitude: dropStop.latitude,
                    longitude: dropStop.longitude,
                    landmark: dropStop.landmark
                } : null,
                effectiveDate: dialogEffectiveDate,
                changeReason: isDialogChangeMode ? selectedChangeReason : undefined,
                isInChangeMode: isDialogChangeMode,
                ...(isDialogChangeMode && dialogNoFeeChange ? { noFeeChange: true } : {}),
                ...(isDialogChangeMode && !dialogNoFeeChange && dialogFeeInstallments.length > 0 ? {
                    installmentNewAmounts: dialogFeeInstallments.map(inst => ({
                        installmentId: inst._id?.toString(),
                        termName: inst.termName,
                        termAmount: inst.termAmount || 0,
                        paidAmount: inst.paidAmount || 0,
                        dueAmount: inst.dueAmount || 0,
                        newAmount: Number(dialogInstallmentNewAmounts[inst._id?.toString()] || 0)
                    }))
                } : {})
            };
        };

        this.setState((prevState) => {
            const updatedUsers = prevState.users.map(updateUserFn);
            const updatedFilteredUsers = prevState.filteredUsers.map(updateUserFn);
            const updatedStudent = updatedFilteredUsers.find(u => u.user_id === uniqueKey);

            return {
                users: updatedUsers,
                filteredUsers: updatedFilteredUsers,
                selectedServices: { ...prevState.selectedServices, [uniqueKey]: dialogServiceId },
                selectedStops: { ...prevState.selectedStops, [uniqueKey]: selectedService?.stops || [] },
                selectedStudentPickup: { ...prevState.selectedStudentPickup, [uniqueKey]: dialogPickupStopId },
                selectedStudentDrop: { ...prevState.selectedStudentDrop, [uniqueKey]: dialogDropStopId },
                selectedStudentsInfo: [...prevState.selectedStudentsInfo.filter(s => s.user_id !== uniqueKey), updatedStudent],
                showAssignmentDialog: false,
                assignmentDialogStudent: null,
                isChangeMode: isDialogChangeMode
                    ? { ...prevState.isChangeMode, [uniqueKey]: true }
                    : prevState.isChangeMode
            };
        }, () => {
            this.toast.show({
                severity: 'success',
                summary: 'Ready for Approval',
                detail: 'Transport assignment configured. Click "Send for approvals" to submit.',
                life: 3000
            });
        });
    };

    // Get current service display text for a student
    getCurrentServiceDisplay = (rowData) => {
        const uniqueKey = rowData.user_id;
        const serviceId = this.state.selectedServices[uniqueKey];
        if (!serviceId) return '-';

        const service = this.state.serviceData.find(s => s.value === serviceId);
        if (!service) return '-';

        const pickupStop = this.state.selectedStudentPickup[uniqueKey];
        const dropStop = this.state.selectedStudentDrop[uniqueKey];
        const pickupStopData = service.stops?.find(s => s.value === pickupStop);
        const dropStopData = service.stops?.find(s => s.value === dropStop);

        return {
            serviceName: service.serviceName || service.label,
            routeName: service.routeName,
            pickupStop: pickupStopData?.stopName || pickupStopData?.label || '-',
            dropStop: dropStopData?.stopName || dropStopData?.label || '-'
        };
    };

    // Add this lifecycle method to maintain scroll position
    componentDidMount() {
        this.loadBusFeePlansSettings();
        // Add custom styles to prevent selection issues with inputs
        const style = document.createElement('style');
        style.innerHTML = `
            .no-selection-highlight .p-selection-column {
                pointer-events: auto !important;
            }
            .prevent-row-selection {
                pointer-events: auto !important;
            }
            .prevent-row-selection * {
                pointer-events: auto !important;
            }
        `;
        document.head.appendChild(style);
    }

    loadBusFeePlansSettings = async () => {
        const academicYear = localStorage.getItem('userAcademicYear');
        const url = `${baseUrlAdmin}/bus-fee-plans?academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const feePlan = res?.res?.data?.feePlans?.[0] || null;
                this.setState({ busFeePlans: feePlan });
            }
        } catch (e) {
            // Non-blocking; settings just won't show pro-rata fields
        }
    };
    renderHeader() {
        return (
            <div className="flex justify-content-between align-items-center">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilterValue} onChange={this.onGlobalFilterChange} placeholder="Name / Phone Number" />
                </span>
                {/* <h5 className="m-0">Customers</h5> */}
            </div>
        )
    }
    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let filters = { ...this.state.filters };
        filters['global'].value = value;
        this.setState({ filters, globalFilterValue: value });
    };
    render() {

        const header = this.renderHeader();
        return (
            <>
                <div className="mt-2 flex justify-content-start align-items-center w-100">
                    <div className="flex flex-column ">
                        <div className="flex align-items-start">
                            <div className="flex justify-content-center align-items-center mt-5 mr-2">
                                <RadioButton
                                    inputId="ingredient1"
                                    onChange={() => this.handleSearchLevel(1)}
                                    checked={this.state.searchLevel === 1}
                                />
                            </div>

                            <div className='flex'>
                                <BranchToSectionDD setValues={this.setDropdownValues} />
                                {/* <BranchToSectionApprovalHierarchy
                                                    selectedValue={this.state.searchLevel}
                                                    setValues={this.setDropdownValues}
                                                    approvalType={'feeConcession'}
                                                /> */}

                                <div className="ml-3 mt-3">
                                    <p className={`ma-label-s2 font-serif font-semibold text-900 text-lg`}>Status</p>
                                    <ClassetMultiSelect
                                        optionLabel="label"
                                        optionValue="value"
                                        value={this.state.statusFilter}
                                        options={transportStatus}
                                        onChange={(e) => {
                                            const selectedStatuses = e.target.value;
                                            this.setState({ statusFilter: selectedStatuses }, () => {
                                                if (!selectedStatuses.length) {
                                                    this.getAssignTransportData();
                                                } else {
                                                    const filteredUsers = this.state.users.filter(user => {
                                                        return selectedStatuses.some(status =>
                                                            status === user.isAssigned ||
                                                            (status === 'NOT ASSIGNED' && !user.isAssigned)
                                                        );
                                                    });
                                                    const selectedServices = {};
                                                    const selectedStops = {};
                                                    const selectedStudentPickup = {};
                                                    const selectedStudentDrop = {};

                                                    filteredUsers.forEach((user) => {
                                                        const uniqueKey = user.user_id;
                                                        // Use V2 field names
                                                        const userServiceId = user.serviceId?.toString?.() || user.serviceId;
                                                        if (userServiceId) {
                                                            selectedServices[uniqueKey] = userServiceId;
                                                            const service = this.state.serviceData.find((s) => s.value === userServiceId);
                                                            if (service) {
                                                                selectedStops[uniqueKey] = service.stops;
                                                            }
                                                        }
                                                        const pickupStopId = user.selectedPickUpStop?._id?.toString?.() || user.selectedPickUpStop?._id;
                                                        const dropStopId = user.selectedDropStop?._id?.toString?.() || user.selectedDropStop?._id;
                                                        selectedStudentPickup[uniqueKey] = pickupStopId;
                                                        selectedStudentDrop[uniqueKey] = dropStopId;
                                                    });

                                                    this.setState({
                                                        filteredUsers, selectedServices,
                                                        selectedStops,
                                                        selectedStudentPickup,
                                                        selectedStudentDrop,
                                                    });
                                                }
                                            });
                                        }}
                                        placeholder={
                                            <div className="flex justify-content-start align-items-center">
                                                <span className="text-lg pl-1">Search by Status</span>
                                            </div>
                                        }
                                        width="250px"
                                        height="48px"
                                        className="text-xl"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* <div style={{ marginLeft: '100px' }} className="flex justify-content-start align-items-center">
                            <span className="">OR</span>
                        </div> */}

                        {/* <div className="flex mt-4">
                            <div className="flex flex-column justify-content-center align-items-center mt-3">
                                <RadioButton
                                    inputId="ingredient2"
                                    onChange={() => this.handleSearchLevel(2)}
                                    checked={this.state.searchLevel === 2}
                                />
                            </div>

                            <div className="field ml-4">
                                <ClassetStudentSearchFilter
                                    ref={this.studentSearchRef}
                                    selectedValue={this.state.searchLevel}
                                    setValues={this.setDropdownValues}
                                />
                            </div>
                        </div> */}
                    </div>

                </div>
                <div className="card datatable-crud-demo mt-2">
                    <DataTable
                        ref={(el) => (this.dt = el)}
                        className="dataTableValuesText no-selection-highlight"
                        columnResizeMode='expand'
                        value={this.state.filteredUsers}
                        dataKey="_id"
                        paginator
                        responsiveLayout="scroll"
                        showGridlines
                        scrollable
                        onPage={this.onPage}
                        first={this.state.lazyParams.first}
                        rows={this.state.lazyParams.rows}
                        totalRecords={this.state.totalRecords}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        globalFilter={this.state.globalFilter}
                        selection={this.state?.selectedStudentsInfo}
                        onSelectionChange={this.onSelectionChange}
                        selectAll={this.state.selectAll}
                        onSelectAllChange={this.onSelectAllChange}
                        selectionMode="checkbox"
                        resizableColumns
                        style={{ width: '100%' }}
                        rowClassName="no-highlight"
                        rowHover={false}
                        lazy
                        header={header}
                        filters={this.state.filters}
                        filterDisplay="menu"
                        loading={this.state.isLoading}
                        globalFilterFields={[
                            'name',
                            'firstName',
                            'lastName',
                            'phone_number',
                            'enrollmentId',
                        ]}
                        tableStyle={{ tableLayout: 'auto' }}
                    >
                        <Column
                            selectionMode="multiple"
                            style={{ width: '50px', maxWidth: '50px' }}
                            headerStyle={{ width: '50px', textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'center' }}
                        />
                        <Column
                            field="enrollmentId"
                            header="Enrollment ID"
                            style={{ minWidth: '130px' }}
                            headerStyle={{ textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'start' }}
                            body={(rowData) => rowData?.enrollmentId || '-'}
                        />
                        <Column
                            header="Student Name"
                            style={{ minWidth: '180px' }}
                            headerStyle={{ textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'start' }}
                            body={(rowData) => {
                                const firstName = rowData?.firstName || rowData?.first_name || '';
                                const lastName = rowData?.lastName || rowData?.last_name || '';
                                return (firstName || lastName) ? `${firstName} ${lastName}`.trim() : (rowData?.name || '-');
                            }}
                        />
                        <Column
                            field="parent"
                            header="Parent Name"
                            style={{ minWidth: '150px' }}
                            headerStyle={{ textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'start' }}
                        />
                        <Column
                            field="phone_number"
                            header="Contact"
                            style={{ minWidth: '130px' }}
                            headerStyle={{ textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'start' }}
                        />
                        <Column
                            header="Status"
                            style={{ minWidth: '120px' }}
                            headerStyle={{ textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'center' }}
                            body={(rowData) => (
                                <span
                                    className="px-2 py-1 border-round font-semibold"
                                    style={{
                                        backgroundColor: rowData?.isAssigned === "ASSIGNED" ? '#E1F7D8'
                                            : rowData?.isAssigned === "PENDING" ? '#FFF4A1'
                                                : '#FFECF1',
                                        color: rowData?.isAssigned === "ASSIGNED" ? '#1E6D00'
                                            : rowData?.isAssigned === "PENDING" ? '#856404'
                                                : '#BF0031',
                                        fontSize: '12px'
                                    }}
                                >
                                    {rowData?.isAssigned || 'NOT ASSIGNED'}
                                </span>
                            )}
                        />
                        <Column
                            header="Current Transport"
                            style={{ minWidth: '280px' }}
                            headerStyle={{ textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'start' }}
                            body={(rowData) => {
                                const serviceInfo = this.getCurrentServiceDisplay(rowData);
                                if (serviceInfo === '-') {
                                    return <span className="text-500">Not configured</span>;
                                }
                                return (
                                    <div style={{ fontSize: '13px', lineHeight: '1.5' }}>
                                        <div className="font-semibold text-900 mb-1">{serviceInfo.serviceName}</div>
                                        <div className="flex flex-column gap-1" style={{ fontSize: '12px' }}>
                                            <div className="text-600 flex align-items-center">
                                                <i className="pi pi-arrow-up text-green-500 mr-1" style={{ fontSize: '10px' }}></i>
                                                <span style={{ wordBreak: 'break-word' }}>{serviceInfo.pickupStop}</span>
                                            </div>
                                            <div className="text-600 flex align-items-center">
                                                <i className="pi pi-arrow-down text-orange-500 mr-1" style={{ fontSize: '10px' }}></i>
                                                <span style={{ wordBreak: 'break-word' }}>{serviceInfo.dropStop}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }}
                        />
                        <Column
                            header="Fee Plan"
                            style={{ minWidth: '100px' }}
                            headerStyle={{ textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'center' }}
                            body={(rowData) => (
                                <span style={{
                                    color: rowData?.isFeePlanAssigned ? '#1E6D00' : '#BF0031',
                                    fontSize: '12px'
                                }}>
                                    {rowData?.isFeePlanAssigned ? '✓ Yes' : '✗ No'}
                                </span>
                            )}
                        />
                        <Column
                            header="Actions"
                            style={{ minWidth: '140px' }}
                            headerStyle={{ textAlign: 'center' }}
                            bodyStyle={{ textAlign: 'center' }}
                            frozen
                            alignFrozen="right"
                            body={(rowData) => {
                                const isSelected = this.state.selectedStudentsInfo.some(s => s._id === rowData._id);
                                const isAssigned = rowData?.isAssigned === "ASSIGNED";
                                const isPending = rowData?.isAssigned === "PENDING";
                                const hasFeePlan = rowData?.isFeePlanAssigned === true;

                                if (isPending) {
                                    return (
                                        <span className="text-500" style={{ fontSize: '12px' }}>
                                            <i className="pi pi-clock mr-1"></i>Pending
                                        </span>
                                    );
                                }

                                if (!hasFeePlan) {
                                    return (
                                        <span className="text-orange-500" style={{ fontSize: '11px' }}>
                                            No fee plan
                                        </span>
                                    );
                                }

                                if (isSelected) {
                                    return (
                                        <div className="flex flex-column align-items-center gap-1">
                                            <span className="text-green-600 font-semibold" style={{ fontSize: '11px' }}>
                                                <i className="pi pi-check-circle mr-1"></i>Ready
                                            </span>
                                            <Button
                                                icon="pi pi-pencil"
                                                className="p-button-text p-button-sm"
                                                style={{ padding: '0.15rem', fontSize: '10px' }}
                                                onClick={() => this.openAssignmentDialog(rowData, isAssigned)}
                                                tooltip="Edit"
                                            />
                                        </div>
                                    );
                                }

                                if (isAssigned) {
                                    return (
                                        <Button
                                            label="Change"
                                            icon="pi pi-sync"
                                            className="p-button-sm p-button-warning p-button-outlined"
                                            style={{ fontSize: '12px', padding: '0.3rem 0.6rem' }}
                                            onClick={() => this.openAssignmentDialog(rowData, true)}
                                        />
                                    );
                                }

                                return (
                                    <Button
                                        label="Assign"
                                        icon="pi pi-plus"
                                        className="p-button-sm p-button-primary"
                                        style={{ fontSize: '12px', padding: '0.3rem 0.6rem' }}
                                        onClick={() => this.openAssignmentDialog(rowData, false)}
                                    />
                                );
                            }}
                        />
                    </DataTable>

                </div>
                <div className="flex justify-content-end mt-2">
                    <Button
                        label="Send for approvals"
                        disabled={this.state.selectedStudentsInfo.length === 0}
                        onClick={() => this.onAssignTransport()}
                        style={{
                            borderRadius: '8px',
                            padding: '0.75rem 1.5rem',
                            fontWeight: 600,
                            background: 'var(--components-button-primary-background-default, #076EFF)',
                            border: 'none',
                            boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1)'
                        }}
                    />
                </div>
                <Dialog
                    visible={this.state.showRouteChangeDialog}
                    onHide={() => this.setState({ showRouteChangeDialog: false })}
                    header="Change Route"
                    headerClassName="text-center"
                    style={{ width: '500px' }}
                >
                    <div className="p-fluid">
                        <div className="field">
                            <label className="add-vehicle-field-label">Route</label>
                            <ClassetDropdown
                                optionLabel={'label'}
                                optionValue={'value'}
                                value={this.state.tempSelectedRoute}
                                options={this.state.vehicleDropdown}
                                onChange={(e) => {
                                    const selectedRoute = this.state.routeData.find(r => r._id === e.value);
                                    this.setState({
                                        tempSelectedRoute: e.value,
                                        tempRouteStops: selectedRoute?.stops || []
                                    });
                                }}
                                placeholder="Select Route"
                            />
                        </div>

                        <div className="field">
                            <label className="add-vehicle-field-label">Pickup Stop</label>
                            <ClassetDropdown
                                optionLabel={'label'}
                                optionValue={'value'}
                                value={this.state.tempSelectedPickup}
                                options={this.state.tempRouteStops?.map(stop => ({
                                    label: stop.stopName,
                                    value: stop._id
                                }))}
                                onChange={(e) => this.setState({ tempSelectedPickup: e.value })}
                                placeholder="Select Pickup Stop"
                            />
                        </div>

                        <div className="field">
                            <label className="add-vehicle-field-label">Drop Stop</label>
                            <ClassetDropdown
                                optionLabel={'label'}
                                optionValue={'value'}
                                value={this.state.tempSelectedDrop}
                                options={this.state.tempRouteStops?.map(stop => ({
                                    label: stop.stopName,
                                    value: stop._id
                                }))}
                                onChange={(e) => this.setState({ tempSelectedDrop: e.value })}
                                placeholder="Select Drop Stop"
                            />
                        </div>

                        <div className="field">
                            <label className="add-vehicle-field-label m-0 p-0">Effective Date</label>
                            <ClassetCalendar
                                value={this.state.tempEffectiveDate}
                                onChange={(e) => this.setState({ tempEffectiveDate: e.value })}
                                placeholder="Select Date"
                            />
                        </div>

                        <div className="flex align-items-center justify-content-center mt-4">
                            <Button
                                label="Send for Approval"
                                onClick={() => {
                                    const student = {
                                        ...this.state.selectedStudent,
                                        routeInfo: this.state.routeData.find(r => r._id === this.state.tempSelectedRoute),
                                        selectedPickUpStop: this.state.tempRouteStops.find(s => s._id === this.state.tempSelectedPickup),
                                        selectedDropStop: this.state.tempRouteStops.find(s => s._id === this.state.tempSelectedDrop),
                                        effectiveDate: this.state.tempEffectiveDate
                                    };
                                    this.onAssignTransport([student]);
                                    this.setState({ showRouteChangeDialog: false });
                                }}
                                className="p-button-primary"
                                style={{ width: '200px' }}
                            />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    visible={this.state.showEffectiveDateDialog}
                    onHide={() => this.setState({ showEffectiveDateDialog: false })}
                    header="Select Effective Date"
                    headerClassName="text-center"
                    style={{ width: '30vw' }}
                >
                    <div className="flex flex-column align-items-center">
                        <ClassetCalendar
                            width={'250px'}
                            height={'48px'}
                            className="border-calendar mb-3"
                            inputClassName="font-semibold"
                            calendarMode={'single'}
                            value={this.state.effectiveDate}
                            placeholder="Select Effective Date"
                            yearRange="2000:2050"
                            onChange={(e) => this.setState({ effectiveDate: e.value })}
                        />
                        <div className="flex justify-content-center mt-3">
                            <Button
                                label="Confirm"
                                style={{ width: '150px' }}
                                onClick={() => { this.setState({ showEffectiveDateDialog: false }, () => this.onAssignTransport()) }}
                                className="p-button-primary my-2"
                            />
                        </div>
                    </div>
                </Dialog>

                {/* Change Transport Reason Dialog */}
                <Dialog
                    visible={this.state.showChangeReasonDialog}
                    onHide={this.onCancelChangeReason}
                    header="Change Transport Assignment"
                    headerClassName="text-center"
                    style={{ width: '450px' }}
                    modal
                    closable={true}
                >
                    <div className="p-fluid">
                        <div className="mb-3">
                            <p className="text-600 mb-3">
                                Please select the reason for changing the transport assignment:
                            </p>
                        </div>

                        <div className="mb-4">
                            {changeReasonOptions.map((option) => (
                                <div key={option.value} className="flex align-items-center mb-3">
                                    <RadioButton
                                        inputId={option.value}
                                        value={option.value}
                                        onChange={(e) => this.setState({ selectedChangeReason: e.value })}
                                        checked={this.state.selectedChangeReason === option.value}
                                    />
                                    <label htmlFor={option.value} className="ml-2 cursor-pointer">
                                        {option.label}
                                    </label>
                                </div>
                            ))}
                        </div>

                        {this.state.selectedChangeReason && (
                            <div
                                className="p-3 border-round mb-3"
                                style={{ backgroundColor: '#D4EDDA', borderLeft: '4px solid #28A745' }}
                            >
                                <p className="m-0" style={{ fontSize: '14px' }}>
                                    ✓ Transport fees will be recalculated based on the new assignment.
                                </p>
                            </div>
                        )}

                        <div className="flex justify-content-center gap-3 mt-4">
                            <Button
                                label="Proceed"
                                onClick={this.onConfirmChangeReason}
                                className="p-button-primary"
                                style={{ width: '120px' }}
                                disabled={!this.state.selectedChangeReason}
                            />
                            <Button
                                label="Cancel"
                                onClick={this.onCancelChangeReason}
                                className="p-button-secondary p-button-outlined"
                                style={{ width: '120px' }}
                            />
                        </div>
                    </div>
                </Dialog>

                {/* Transport Assignment Dialog */}
                <Dialog
                    visible={this.state.showAssignmentDialog}
                    onHide={this.closeAssignmentDialog}
                    header={
                        <div className="flex align-items-center gap-2">
                            <i className={`pi ${this.state.isDialogChangeMode ? 'pi-sync' : 'pi-plus-circle'}`}
                                style={{ fontSize: '1.2rem', color: this.state.isDialogChangeMode ? '#F59E0B' : '#076EFF' }}
                            ></i>
                            <span>{this.state.isDialogChangeMode ? 'Change Transport Assignment' : 'Assign Transport'}</span>
                        </div>
                    }
                    style={{ width: '700px' }}
                    modal
                    closable={true}
                    className="transport-assignment-dialog"
                >
                    {this.state.assignmentDialogStudent && (
                        <div className="p-fluid">
                            {/* Student Info Header */}
                            <div className="surface-100 border-round p-3 mb-4">
                                <div className="flex align-items-center gap-3">
                                    <div className="flex align-items-center justify-content-center bg-primary border-circle" style={{ width: '45px', height: '45px' }}>
                                        <i className="pi pi-user text-white" style={{ fontSize: '1.2rem' }}></i>
                                    </div>
                                    <div>
                                        <div className="font-semibold text-900" style={{ fontSize: '16px' }}>
                                            {this.state.assignmentDialogStudent?.firstName || ''} {this.state.assignmentDialogStudent?.lastName || ''}
                                        </div>
                                        <div className="text-500" style={{ fontSize: '13px' }}>
                                            {this.state.assignmentDialogStudent?.enrollmentId} • {this.state.assignmentDialogStudent?.phone_number}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Change Reason Section - Only for Change Mode */}
                            {this.state.isDialogChangeMode && (
                                <>
                                    <div className="mb-4">
                                        <label className="font-semibold text-900 mb-2 block">Reason for Change *</label>
                                        <div className="flex gap-3">
                                            {changeReasonOptions.map((option) => (
                                                <div key={option.value} className="flex align-items-center">
                                                    <RadioButton
                                                        inputId={`dialog-${option.value}`}
                                                        value={option.value}
                                                        onChange={(e) => this.setState({ selectedChangeReason: e.value })}
                                                        checked={this.state.selectedChangeReason === option.value}
                                                    />
                                                    <label htmlFor={`dialog-${option.value}`} className="ml-2 cursor-pointer" style={{ fontSize: '13px' }}>
                                                        {option.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        {this.state.selectedChangeReason && !this.state.dialogNoFeeChange && (
                                            <div
                                                className="p-2 border-round mt-2"
                                                style={{ backgroundColor: '#D4EDDA', fontSize: '12px' }}
                                            >
                                                ✓ Fees will be recalculated based on the new route
                                            </div>
                                        )}
                                    </div>

                                    <div className="flex align-items-center mb-4 p-3 border-round" style={{ backgroundColor: '#FFF7ED', border: '1px solid #FED7AA' }}>
                                        <Checkbox
                                            inputId="dialog-no-fee-change"
                                            checked={this.state.dialogNoFeeChange}
                                            onChange={(e) => this.setState({ dialogNoFeeChange: e.checked })}
                                        />
                                        <label htmlFor="dialog-no-fee-change" className="ml-2 cursor-pointer" style={{ fontSize: '13px', color: '#92400E' }}>
                                            <span className="font-semibold">No Fee Change</span> — Update route only, skip all fee recalculations
                                        </label>
                                    </div>

                                    {/* Transport Fee Installments Table with per-row New Entry Amount */}
                                    {!this.state.dialogNoFeeChange && (
                                        <>
                                            <Divider />
                                            <div className="mb-3">
                                                <p className="font-semibold text-900 mb-2" style={{ fontSize: '14px' }}>
                                                    <i className="pi pi-list mr-2"></i>Current Transport Fee Installments
                                                </p>
                                                {this.state.dialogFeeInstallmentsLoading ? (
                                                    <div className="flex justify-content-center py-3">
                                                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5rem', color: '#076EFF' }}></i>
                                                    </div>
                                                ) : this.state.dialogFeeInstallments.length > 0 ? (
                                                    <>
                                                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                                                            <thead>
                                                                <tr style={{ backgroundColor: '#F3F4F6' }}>
                                                                    <th style={{ textAlign: 'left', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>Term Name</th>
                                                                    <th style={{ textAlign: 'right', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>Term Amount (₹)</th>
                                                                    <th style={{ textAlign: 'right', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>Paid (₹)</th>
                                                                    <th style={{ textAlign: 'right', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>Due (₹)</th>
                                                                    <th style={{ textAlign: 'center', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>New Entry Amount (₹) *</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.dialogFeeInstallments.map((inst, idx) => {
                                                                    const key = inst._id?.toString();
                                                                    const newAmt = this.state.dialogInstallmentNewAmounts[key] ?? '';
                                                                    const isInvalid = newAmt !== '' && !isNaN(Number(newAmt)) && Number(newAmt) < (inst.paidAmount || 0);
                                                                    return (
                                                                        <tr key={key || idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#F9FAFB' }}>
                                                                            <td style={{ padding: '7px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterRegular' }}>{inst.termName}</td>
                                                                            <td style={{ padding: '7px 10px', border: '1px solid #E5E7EB', textAlign: 'right', fontFamily: 'InterRegular' }}>
                                                                                {inst.termAmount?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </td>
                                                                            <td style={{ padding: '7px 10px', border: '1px solid #E5E7EB', textAlign: 'right', color: '#16A34A', fontFamily: 'InterRegular' }}>
                                                                                {inst.paidAmount?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </td>
                                                                            <td style={{ padding: '7px 10px', border: '1px solid #E5E7EB', textAlign: 'right', color: inst.dueAmount > 0 ? '#DC2626' : '#16A34A', fontFamily: 'InterRegular' }}>
                                                                                {inst.dueAmount?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </td>
                                                                            <td style={{ padding: '4px 8px', border: `1px solid ${isInvalid ? '#DC2626' : '#E5E7EB'}` }}>
                                                                                <ClassetInputText
                                                                                    value={newAmt}
                                                                                    onChange={(e) => {
                                                                                        this.setState((prev) => ({
                                                                                            dialogInstallmentNewAmounts: {
                                                                                                ...prev.dialogInstallmentNewAmounts,
                                                                                                [key]: e.target.value
                                                                                            }
                                                                                        }));
                                                                                    }}
                                                                                    keyfilter="pnum"
                                                                                    placeholder="0.00"
                                                                                    width="140px"
                                                                                    height="36px"
                                                                                />
                                                                                {isInvalid && (
                                                                                    <small style={{ color: '#DC2626', fontSize: '11px', display: 'block', marginTop: '2px' }}>
                                                                                        ⚠ Cannot be less than ₹{inst.paidAmount}
                                                                                    </small>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>

                                                        {/* Summary: Old Total vs New Total */}
                                                        {(() => {
                                                            const amounts = Object.values(this.state.dialogInstallmentNewAmounts);
                                                            const allFilled = amounts.length === this.state.dialogFeeInstallments.length &&
                                                                amounts.every(v => v !== '' && !isNaN(Number(v)));
                                                            if (!allFilled) return null;
                                                            const oldTotal = this.state.dialogFeeInstallments.reduce((sum, i) => sum + (i.termAmount || 0), 0);
                                                            const newTotal = amounts.reduce((sum, v) => sum + Number(v), 0);
                                                            return (
                                                                <div className="mt-3 p-3 border-round" style={{ backgroundColor: '#EFF6FF', border: '1px solid #BFDBFE' }}>
                                                                    <p className="m-0 mb-2 font-semibold" style={{ fontSize: '13px', color: '#1E40AF' }}>Fee Summary</p>
                                                                    <div className="flex justify-content-between" style={{ fontSize: '13px' }}>
                                                                        <span style={{ fontFamily: 'InterRegular' }}>Old Total Amount:</span>
                                                                        <span style={{ fontFamily: 'InterSemiBold', color: '#374151' }}>
                                                                            ₹{oldTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </span>
                                                                    </div>
                                                                    <div className="flex justify-content-between mt-1" style={{ fontSize: '13px' }}>
                                                                        <span style={{ fontFamily: 'InterRegular' }}>New Total Amount:</span>
                                                                        <span style={{ fontFamily: 'InterSemiBold', color: newTotal < oldTotal ? '#DC2626' : '#1D4ED8' }}>
                                                                            ₹{newTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })()}
                                                    </>
                                                ) : (
                                                    <div className="text-500 text-sm py-2">No transport fee installments found for this student.</div>
                                                )}
                                            </div>
                                        </>
                                    )}

                                    <Divider />
                                </>
                            )}

                            {/* Service Selection */}
                            <div className="field mb-4">
                                <label className="font-semibold text-900 mb-2 block">
                                    <i className="pi pi-car mr-2"></i>Transport Service *
                                </label>
                                <ClassetDropdown
                                    optionLabel="label"
                                    optionValue="value"
                                    width="100%"
                                    height="48px"
                                    className="text-xl"
                                    value={this.state.dialogServiceId}
                                    options={this.state.vehicleDropdown}
                                    onChange={(e) => this.onDialogServiceChange(e.target.value)}
                                    placeholder="Select a transport service"
                                />
                                {this.state.dialogServiceId && (
                                    <div className="text-500 mt-1" style={{ fontSize: '12px' }}>
                                        {(() => {
                                            const service = this.state.serviceData.find(s => s.value === this.state.dialogServiceId);
                                            return service ? `Route: ${service.routeName || '-'} • Vehicle: ${service.vehicleNumber || '-'}` : '';
                                        })()}
                                    </div>
                                )}
                            </div>

                            {/* Pickup & Drop in a row */}
                            <div className="grid mb-4">
                                <div className="col-6">
                                    <label className="font-semibold text-900 mb-2 block">
                                        <i className="pi pi-arrow-up text-green-500 mr-2"></i>Pickup Stop
                                    </label>
                                    <ClassetDropdown
                                        optionLabel="label"
                                        optionValue="value"
                                        width="100%"
                                        height="48px"
                                        className="text-xl"
                                        value={this.state.dialogPickupStopId}
                                        options={this.state.dialogStops}
                                        onChange={(e) => this.onDialogPickupChange(e.target.value)}
                                        placeholder="Select pickup"
                                        disabled={!this.state.dialogServiceId}
                                    />
                                </div>
                                <div className="col-6">
                                    <label className="font-semibold text-900 mb-2 block">
                                        <i className="pi pi-arrow-down text-orange-500 mr-2"></i>Drop Stop
                                    </label>
                                    <ClassetDropdown
                                        optionLabel="label"
                                        optionValue="value"
                                        width="100%"
                                        height="48px"
                                        className="text-xl"
                                        value={this.state.dialogDropStopId}
                                        options={this.state.dialogStops}
                                        onChange={(e) => this.onDialogDropChange(e.target.value)}
                                        placeholder="Select drop"
                                        disabled={!this.state.dialogServiceId}
                                    />
                                </div>
                            </div>
                            <div className="text-500 mb-3" style={{ fontSize: '12px', marginTop: '-0.5rem' }}>
                                * Select at least one stop (pickup or drop)
                            </div>

                            {/* Effective Date */}
                            <div className="field mb-4">
                                <label className="font-semibold text-900 mb-2 block">
                                    <i className="pi pi-calendar mr-2"></i>Effective Date *
                                </label>
                                <ClassetCalendar
                                    width="100%"
                                    height="48px"
                                    className="border-calendar"
                                    inputClassName="font-semibold"
                                    calendarMode="single"
                                    value={this.state.dialogEffectiveDate}
                                    placeholder="Select effective date"
                                    yearRange="2000:2050"
                                    onChange={(e) => this.setState({ dialogEffectiveDate: e.value })}
                                />
                            </div>



                            <Divider />

                            {/* Action Buttons */}
                            <div className="flex justify-content-end gap-3 mt-4">
                                <Button
                                    label="Cancel"
                                    onClick={this.closeAssignmentDialog}
                                    className="p-button-secondary p-button-outlined"
                                    style={{ width: '120px' }}
                                />
                                <Button
                                    label={this.state.isDialogChangeMode ? 'Confirm Change' : 'Add to Queue'}
                                    icon={this.state.isDialogChangeMode ? 'pi pi-check' : 'pi pi-plus'}
                                    onClick={this.submitAssignmentDialog}
                                    className="p-button-primary"
                                    style={{ width: '160px' }}
                                    disabled={
                                        !this.state.dialogServiceId ||
                                        (!this.state.dialogPickupStopId && !this.state.dialogDropStopId) ||
                                        !this.state.dialogEffectiveDate ||
                                        (this.state.isDialogChangeMode && !this.state.selectedChangeReason) ||
                                        (this.state.isDialogChangeMode && this.state.dialogFeeInstallmentsLoading)
                                    }
                                />
                            </div>
                        </div>
                    )}
                </Dialog>

                {this.state.isLoading && (
                    <>
                        <LoadingComponent />
                    </>
                )}                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha')
});

export default connect(mapStateToProps, { getBoardsData })(Authentication(withRouter(AssignManagementTable)));
